import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Layout = ({ content }) => {
    return (
        <div className={styles.layout}>
            <div className={styles.toast}>{content}</div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.string,
};

export default errorBoundary(Layout);
